export default "__VITE_ASSET__ginid8D1__"